import { createContext, useContext, type ReactNode } from "react"

import type { CoachThreadApi } from "@/components/coach-thread"

/**
 * Der laufende Verlauf, erreichbar von unten.
 *
 * Eine Karte in einer Nachricht steckt drei Ebenen tief (Thread → Bubble →
 * Werkzeugkarte) und hat sonst keinen Weg, selbst etwas zu senden. Die
 * Prüfungskarte braucht genau das: nach dem Absenden einer Antwort muss der
 * Coach darauf reagieren, und das ist ein normaler Gesprächszug.
 *
 * Eigene Datei und nicht in `coach-thread.tsx`, weil die Karte sonst den
 * Thread importieren würde, der die Karte importiert.
 */
const CoachThreadApiContext = createContext<CoachThreadApi | null>(null)

export function CoachThreadApiProvider({
  value,
  children,
}: {
  value: CoachThreadApi
  children: ReactNode
}) {
  return (
    <CoachThreadApiContext.Provider value={value}>
      {children}
    </CoachThreadApiContext.Provider>
  )
}

/** Null außerhalb eines Verlaufs — etwa im Test, der die Karte allein rendert. */
export function useCoachThreadApi(): CoachThreadApi | null {
  return useContext(CoachThreadApiContext)
}
